import React from 'react';
import { formatCurrency, formatWeekRange, PlanPeriod, PlanWeek, WeekStatus } from '../../../../utils';
import { getPercent, getProgressLevel } from './planDisplay';

interface WeeklyBreakdownProps {
  weeks: PlanWeek[];
  period: PlanPeriod;
}

const STATUS_INDICATOR: Record<WeekStatus, string> = {
  past: 'completed',
  current: 'active',
  future: 'upcoming'
};

const WeeklyBreakdown: React.FC<WeeklyBreakdownProps> = ({ weeks, period }) => (
  <div className="monthly-plan-weeks">
    {weeks.map(week => {
      const netSpent = week.spent - week.returned;
      const usage = week.budget > 0 ? getPercent(netSpent, week.budget) : netSpent > 0 ? 200 : 0;
      const level = getProgressLevel(usage);
      const hasCarryOver = Math.abs(week.carryOver) >= 0.01;

      return (
        <div key={week.index} className={`monthly-plan-week monthly-plan-week-${week.status}`}>
          <div className="monthly-plan-week-header">
            <div className="monthly-plan-week-title">
              <span className={`budget-status-indicator budget-status-indicator-${STATUS_INDICATOR[week.status]}`}></span>
              <span className="monthly-plan-week-name">Тиждень {week.index + 1}</span>
              <span className="monthly-plan-week-dates">{formatWeekRange(week, period)}</span>
              {week.status === 'current' && <span className="budget-type-badge">Зараз</span>}
            </div>
            <div className="monthly-plan-week-left-wrap">
              <span className={`monthly-plan-week-left ${week.left < 0 ? 'negative' : 'positive'}`}>
                {formatCurrency(week.left)}
              </span>
              <span className="monthly-plan-week-left-label">
                {week.status === 'past' ? (week.left < 0 ? 'перевитрата' : 'залишок') : 'доступно'}
              </span>
            </div>
          </div>

          <div className="budget-category-progress">
            <div
              className={`budget-category-progress-fill category-progress-${level}`}
              style={{ width: `${Math.max(0, Math.min(usage, 100))}%` }}
            ></div>
            {usage > 100 && (
              <div
                className="budget-category-progress-overfill"
                style={{ width: `${Math.min(usage - 100, 100)}%` }}
              ></div>
            )}
          </div>

          <div className="monthly-plan-week-meta">
            <span>Бюджет {formatCurrency(week.budget)}</span>
            {hasCarryOver && (
              <span className={week.carryOver > 0 ? 'positive' : 'negative'}>
                {week.carryOver > 0 ? '+' : '−'}{formatCurrency(Math.abs(week.carryOver))} перенесено
              </span>
            )}
            <span>Витрачено {formatCurrency(week.spent)}</span>
            {week.returned > 0 && (
              <span className="positive">+{formatCurrency(week.returned)} повернуто</span>
            )}
          </div>
        </div>
      );
    })}
  </div>
);

export default WeeklyBreakdown;
